import {Language as LegacyLanguage} from 'gabi-api-js/common/enums/enums_pb';
import {Language} from 'gabi-api-ts/v2/common/enums/enums';
import {$enum} from 'ts-enum-util';

export function getI18nLanguageKey(language: Language | LegacyLanguage | '') {
    if (language === '') {
        language = Language.LANGUAGE_NOT_SET;
    }
    switch (language) {
    case Language.LANGUAGE_NOT_SET:
    case Language.English:
    case LegacyLanguage.ENGLISH:
        return 'en';
    case Language.French:
    case LegacyLanguage.FRENCH:
        return 'fr';
    case Language.Spanish:
    case LegacyLanguage.SPANISH:
        return 'es';
    }
}

export function parseIntToLanguage(value: number): Language {
    for (const language of $enum(Language).getEntries()) {
        if (language[1] === value) {
            return Language[language[0]];
        }
    }
    return Language.LANGUAGE_NOT_SET;
}
